const state = {
  taskEditVisible: false,
  type: "edit",
  currentNode: {}, // 节点数据
  assistRoleId: null,
  editNode: {}, // 编辑的树节点对象
  selectNode: {}, // 选中的树节点
  taskList: [],
};

const getters = {};
const mutations = {
  setData(state, { key, value }) {
    state[key] = value;
  },
  showTaskEdit(state, boolean) {
    state.taskEditVisible = boolean;
  },
  setNode(state, node) {
    state.currentNode = node;
  },
  setEditNode(state, node) {
    state.editNode = node;
  },
  setSelectNode(state, node) {
    state.selectNode = node;
  },
  setType(state, type) {
    state.type = type;
  },
  setTaskList(state, taskList) {
    state.taskList = taskList;
  },
  setAssistRoleId(state, assistRoleId) {
    state.assistRoleId = assistRoleId;
  },
};
const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
